import { useEffect } from 'react';
import { create } from 'zustand';

type TLoadingState = {
  loading: boolean;
  setLoading: (loading: boolean) => void;
};

const loadingStore = create<TLoadingState>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),
}));

export const useLoading = Object.assign(
  (isLoading?: boolean) => {
    const loading = loadingStore((state) => state.loading);
    const setLoading = loadingStore((state) => state.setLoading);

    useEffect(() => {
      if (isLoading === undefined) return;
      setLoading(isLoading);
    }, [isLoading, setLoading]);

    return { loading, setLoading };
  },
  {
    getState: () => loadingStore.getState(),
    setState: (state: Partial<TLoadingState>) => loadingStore.setState(state),
    subscribe: (
      listener: (state: TLoadingState, prevState: TLoadingState) => void,
    ) => loadingStore.subscribe(listener),
  },
);
